import api from '@/lib/api';

export interface CVTemplate {
  name: string;
  path: string;
}

export interface CVDataPreview {
  nbExp: string;
  titre_poste: string;
  coordonnees_personnelles: {
    trigramme: string;
    nom: string;
    prenom: string;
    ville?: string;
    telephone?: string;
    email?: string;
  };
  competences: Array<{ categorie: string; listComp: string[] }>;
  experiences_professionnelles: Array<{
    titre_poste: string;
    entreprise: string;
    date_debut: string;
    date_fin: string;
    description: string;
  }>;
  diplomes_certifications: Array<{
    nom: string;
    etablissement: string;
    date_debut: string;
    date_fin: string;
  }>;
  langues: string[];
  liens_projets: string[];
}

const BASE_URL = '/itc/cv-generator';

export const cvGeneratorService = {
  /**
   * Recupere la liste des templates disponibles pour la societe de l'utilisateur
   */
  async getTemplates(): Promise<{ templates: CVTemplate[]; companyName: string }> {
    const { data } = await api.get<{ templates: CVTemplate[]; companyName: string }>(
      `${BASE_URL}/templates`,
    );
    return data;
  },

  /**
   * Genere et telecharge un CV au format DOCX
   */
  async generateCV(
    candidateId: number,
    template: string,
  ): Promise<Blob> {
    const { data } = await api.post(
      `${BASE_URL}/candidates/${candidateId}/generate`,
      { template },
      { responseType: 'blob' },
    );
    return data;
  },

  /**
   * Previsualise les donnees CV d'un candidat
   */
  async previewCVData(candidateId: number): Promise<CVDataPreview> {
    const { data } = await api.get<{ data: CVDataPreview }>(
      `${BASE_URL}/candidates/${candidateId}/preview`,
    );
    return data.data;
  },

  /**
   * Telecharge le CV genere
   */
  downloadCV(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
